// extracted by mini-css-extract-plugin
module.exports = {"block":"PlayerRankingsList_block__zvrmQ","player":"PlayerRankingsList_player__RjP8J","center":"PlayerRankingsList_center__ANn7Q","ad":"PlayerRankingsList_ad__zLIKG"};